<ng-container #prefix />
<div class="label">
  <rt-icon [name]="iconName()" [size]="iconSize()" />
</div>
<ng-container #suffix />
